<script setup lang="ts">
import { ArrowLeft, ArrowRight, Check, ClipboardCheck, Phone, ShieldCheck } from "lucide-vue-next";
import { computed, watchEffect } from "vue";
import { useRoute } from "vue-router";
import { getService } from "@/data/services";
import "@/assets/styles/service-detail.css";

const route = useRoute();
const service = computed(() => getService(String(route.params.slug)));
watchEffect(() => { if (service.value) document.title = `${service.value.title} | Dachdecker Beispiel`; });
</script>

<template>
  <main v-if="service" class="service-detail">
    <section class="detail-hero" :style="{ '--service-image': `url(/images/services/${service.slug}.png)` }">
      <div class="detail-wrap">
        <RouterLink to="/leistungen" class="back-link"><ArrowLeft /> Alle Leistungen</RouterLink>
        <span class="section-badge">Leistung im Detail</span>
        <h1>{{ service.title }}</h1>
        <p>{{ service.intro }}</p>
        <div class="detail-actions">
          <RouterLink to="/kontakt" class="detail-btn primary"><Phone /> Projekt anfragen</RouterLink>
          <a href="tel:+49123456789" class="detail-btn secondary">Direkt anrufen</a>
        </div>
      </div>
    </section>

    <section class="detail-content">
      <div class="detail-wrap detail-grid">
        <div>
          <span class="section-badge">Leistungsumfang</span>
          <h2>Darauf können Sie sich verlassen</h2>
          <ul class="benefit-list">
            <li v-for="item in service.benefits" :key="item"><Check />{{ item }}</li>
          </ul>
        </div>
        <aside class="quality-card">
          <ShieldCheck />
          <span>Meisterqualität</span>
          <h3>Sauber geplant. Fachgerecht ausgeführt.</h3>
          <p>Sie erhalten eine verständliche Empfehlung, transparente Schritte und eine sorgfältige Übergabe.</p>
        </aside>
      </div>
    </section>

    <section class="process-section">
      <div class="detail-wrap">
        <div class="process-heading"><span class="section-badge">Unser Ablauf</span><h2>In vier klaren Schritten</h2></div>
        <ol class="process-grid">
          <li v-for="(step, index) in service.steps" :key="step"><span>0{{ index + 1 }}</span><ClipboardCheck /><strong>{{ step }}</strong></li>
        </ol>
        <RouterLink to="/kontakt" class="detail-cta">Unverbindlich beraten lassen <ArrowRight /></RouterLink>
      </div>
    </section>
  </main>
  <main v-else class="not-found">
    <h1>Leistung nicht gefunden</h1><RouterLink to="/leistungen">Zurück zu allen Leistungen</RouterLink>
  </main>
</template>
